import React from 'react';

import { observer } from 'mobx-react';

import {
  FooterContainer,
  ReasonContainer,
} from 'containers/Tasks/components/ActionsSchedulesTable/ScheduleDrawer/styles';
import { RiskActionDetail, RiskActionStatus } from 'utils/api/modules/risks';
import { formatMoment } from 'utils/formatters/timezone';

import { StyledInfoIcon } from './styles';

const ControlActionFooter: React.FunctionComponent<{ action: RiskActionDetail }> = ({ action }) => {
  if (action.status === RiskActionStatus.Cancelled) {
    return (
      <FooterContainer>
        <ReasonContainer data-testid="control-action-cancelled-info">
          <StyledInfoIcon />
          <div>
            <h1>{action.cancelReason || 'Cancelled'}</h1>
            <p>
              {action.cancelledBy?.name ?? 'Someone'} archived the control on {formatMoment(action.cancelledAt)}. No
              more reminders will be sent.
            </p>
          </div>
        </ReasonContainer>
      </FooterContainer>
    );
  }

  if (action.status === RiskActionStatus.Done) {
    const who = action.completedBy?.name;
    const when = formatMoment(action.completedAt);
    return (
      <FooterContainer>
        <ReasonContainer data-testid="control-action-done-info">
          <StyledInfoIcon />
          <div>
            <h1>In place</h1>
            <p>
              {action.evidence
                ? `${who ?? 'Someone'} submitted this on ${when}. The control is in place on every risk it's on.`
                : `Set In place by ${who ?? 'someone'} on ${when}. No evidence was submitted.`}
            </p>
          </div>
        </ReasonContainer>
      </FooterContainer>
    );
  }

  return null;
};

export default observer(ControlActionFooter);
